<template>
   <div class="topContainer">
      <div class="pageHeader">What is Men of Courage International, Inc?</div>
      <div class="sectionInfo">
       <div class="sectionContent">
         <b-list-group horizontal="md">
         <b-list-group-item><img :src="rotary" class="imgSize"/><div class="accentItalic">Our motto: 'Better Together'</div></b-list-group-item>
         <b-list-group-item class="paragraphSection">
            <div class="sectionHeader">Better Together</div>
            <p> A 501 (c)(3) nonprofit Annapolis-based organization dedicated to helping men fulfill their duties as fathers, 
              husbands, community members and leaders. It provides a safe place for men to talk about how to reach their goal of 
              achieving authentic manhood; servant leadership. It also provides mental health and educational support for family members
               through our partnership with other nonprofit and for profit organizations. 
            </p>
            <div class="sectionInfoRedBlur">The <span class="accentText">MOCI Men's Discussion</span> will be held on the 1st and 3rd Friday every month on a Zoom discussion from 7:00am to 7:45am.  Please contact us via email (drf@menofcourageinternational.org) for Zoom link.</div>
         </b-list-group-item>
         </b-list-group>
       </div> 
       <div class="sectionContent" style="margin-top:20px">
         <b-list-group horizontal="md">
         <b-list-group-item><img :src="logo" class="imgSize"/></b-list-group-item>
         <b-list-group-item class="paragraphSectionLg">
               <div class="accentText">What does our Logo represent?</div>
                <div style="margin-top:10px;">The Crimson Red color represents <span class="bTitle">"honor"</span> and <span class="bTitle">"courage"</span></div>
                <div style="margin-top:10px;">The shield implies the need to be <span class="bTitle">ready to protect</span> and win the battle of morality for our families and communities.</div>
                <div style="margin-top:10px;">It also denotes the need to <span class="bTitle">prepare our children</span> to build strong characters and be upstanding members in the community. The three masculine faces represent the <span class="bTitle">unity among all men</span> that is imperative to achieve the goal of being men of courage and servant leaders in society</div>
           </b-list-group-item>
         </b-list-group>
       </div> 
      </div>
   </div>
</template>
<script>
export default {
  data: function () {
     return { 
       rotary : require('@/assets/rotary.jpg'),
       logo : require('@/assets/logo.jpg'),
       kavan: require('@/assets/kavan.jpg'),
       mccord: require('@/assets/mccord.jpg'),
       ehrlich: require('@/assets/ehrlich.jpg')
     }
  }
}
</script>
<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/logoBorder.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
@media screen and (max-width: 399px){
 .imgSize {
   height: 215px;
   margin: 5px 5px;
 }
}
@media screen and (min-width: 400px){
 .imgSize {
   height: 220px;
   margin: 5px 5px;
 }
}
.paragraphSection,.paragraphSectionLg{
   margin-left: 10px;
   margin-top: 5px;
   color: #332e2f;
}
.paragraphSectionLg{
  font-size: 1.1em;
}
.bigText{
  font-size: 1.4em;
}
.bTitle{
  font-weight: bold;
}
.listItemsRed, .listItemsBlue{
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 5px;
  margin: 10px
}
.listItemsRed{
  background-color: #dabbbb
}
.listItemsBlue{
  background-color: lightblue
}
.listItem{
  margin-left:10px;
}
.listItem::before{
  content: '* ';
  font-size: 1.2em;
  font-weight: bold;
}
.accentText, .accentTextSm{
  color: #851e26;
  font-weight: bold;
}
.accentText{ font-size: 1.3em;}
.accentTextSm{ font-size: 1.1em;}
.accentItalic{
  color: #851e26;
  font-size: 1.1em;
  font-weight:bold;
  text-align: center;
  font-style:italic;
}
.sectionInfo, .sectionInfoAlt{
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 5px;
}
.sectionInfo{
  background-color: #f0f0f0;
  margin-top: 27px;
}
.sectionInfoAlt{
  background-color: rgb(62, 62, 96);
  margin: 10px;
}
.sectionInfoAlt div.list-group-item{
  color: #fff;
  background-color: rgb(62, 62, 96);
}
.sectionInfoRedBlur{
  margin: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  border: 1px solid;
  padding: 10px;
  box-shadow: 5px 10px 18px #851e26;
}
.sectionContent{
  margin-top:0px;
}
</style>
